import React, { useEffect, useRef, useState } from 'react';
import classnames from 'classnames';
import { Form, Button, InputGroup } from 'react-bootstrap';
import { useSelector } from 'react-redux';

import messageService from './../../Services/message';
import FileUploaderMessage from './FileUploaderMessage.jsx';
import Message from './Message.jsx'


const Chat = ({ socket, privateChatUser }) =>{
    const [mensajes, setMensajes] = useState([]);
    const [privateMensajes, setPrivateMensajes] = useState([]);
    const [fileAttachSelector, setFileAttachSelector] = useState(false)
    
    const { publicId, name } = useSelector(state => state.user);
    
    const nombreRef = useRef('');
    const chatList = useRef(null);


    const addMessageToChat = message =>{
        console.log('private', privateChatUser.publicId, privateChatUser.socket)
        console.log('logica privada1: ', message?.author === privateChatUser.publicId, 'logica privada2: ', message?.author === publicId)
        if(!message?.dest)  return setMensajes( prev => [...prev, message])
        else if( message?.author === privateChatUser.publicId || message?.author === publicId) return setPrivateMensajes( prev => [...prev, message])
    }

    const sendMessage = attachment =>{
        if (nombreRef.current.value){
            let message = {
                author: publicId, 
                name, 
                message: nombreRef.current.value, 
                time: new Date().toLocaleTimeString('es-CO')
            }

            if(attachment) message.attachment = attachment;

            if(!privateChatUser)
                socket.emit('message', message);
            else{
                message = {...message, dest: privateChatUser.publicId }
                delete message.name;
                socket.emit('privateMessage', message);
            }
            nombreRef.current.value = '';
            addMessageToChat(message);
        }
    }

    const toggleFileAttachSelector = () => setFileAttachSelector(!fileAttachSelector);
    
    const sendAttachment = (attachment) =>{
        toggleFileAttachSelector();
        sendMessage(attachment)
    }

   useEffect(()=>{
        socket.on('incommingMessage', data=>{   
            addMessageToChat(data);
        });
        return ()=>socket.disconnect()
    },[])

    useEffect(()=>{
        chatList.current.scrollTop = chatList.current.scrollHeight;
    },[mensajes, privateMensajes])
   

    useEffect(()=>{
        const fetchMessagePrivate = async() =>{
            const res = await messageService.getPrivateChat(publicId, privateChatUser.publicId);
            if(res.success){
                setPrivateMensajes(res.messages);
            }
        }
        const fetchMessagePublic = async() =>{
            const res = await messageService.getPublicMessages();
            if(res.success){
                setMensajes(res.messages);
            }
        }

        if(privateChatUser ) fetchMessagePrivate()
        else if( !mensajes.length) fetchMessagePublic();

    },[privateChatUser])

    const checkEnterSend = e =>{
        if(e.key === 'Enter')
            sendMessage();
    }

    return(
        <div className='d-flex flex-column w-100 h-100 m-0' onKeyDown={checkEnterSend}>   
            <div className={classnames('py-2 bg-success px-3 text-white font-weight-bold', {'d-none': !privateChatUser.publicId})}>
                <div className='d-flex justify-content-between'>
                    <div>Chat Privado</div>
                    <div>{privateChatUser.name} </div>
                </div>
            </div>
            <div className='d-flex flex-column p-3 m-0 overflow-auto flex-grow-1 chatlist' ref={chatList}>
                {   
                    privateChatUser ?
                        privateMensajes?.map((m,idx)=>(
                            <Message data={m} key={idx} youId={publicId}/>
                        )) 
                        :
                        mensajes?.map((m,idx)=>(
                            <Message data={m} key={idx} youId={publicId}/>
                        )) 
                        
                }
            </div>
            <div className='p-3' >
                <InputGroup>
                    <Form.Control 
                        type='text'
                        ref={nombreRef}
                        aria-describedby="basic-addon1"
                        placeholder='Enter your message' 
                        className='mr-0' 
                    />
                    <InputGroup.Append className='m-0 pointer'>
                        <Button  variant='light' className='d-flex py-0 form-control' onClick={toggleFileAttachSelector}>
                            <i className='material-icons font15 align-self-center '>attach_file</i>
                        </Button>
                        <Button variant='dark' onClick={sendMessage} className='d-flex'>
                            <i className='material-icons mr-2 font15 align-self-center'>send_to_mobile</i>Send
                        </Button>
                    </InputGroup.Append>
                </InputGroup>
            </div>
            <FileUploaderMessage show={fileAttachSelector} hide={toggleFileAttachSelector} callback={sendAttachment}/>
        </div>
    )
}

export default Chat;